export enum ExtraParamsAPI
{
    GET_PARAM_BY_UUID           =   "param/uuid"             ,
    GET_PARAM_BY_CODE           =   "param/level"            ,
    GET_PARAMS_BY_CODES         =   "param/level/list"       ,
}